export enum UseroidTypes {
  PROVIDER_SAML2 = 'SAML2',
  PROVIDER_YAMMER = 'Yammer',
  PROVIDER_AZURE = 'Azure',
  PROVIDER_MEDALLIA = 'MEC',
  PROVIDER_SSOPROXY = 'SSOPROXY',
  PROVIDER_SLACK = 'Slack'
}
